// 앱 전역 리포터 하나. 인터셉터·ErrorBoundary·errorHandler 는 이것만 import 해 capture 를 부른다.
// onDrop 은 로컬에서만 콘솔에 남겨 "왜 안 갔지" 를 바로 보게 한다.

import {
  createReporter,
  resolveDropMode,
  resolveTagSampleRate,
} from '@mathflat/shared/@modules/errorReporting'

import { studentPolicy } from './policy'
import { sentryAdapter } from './sentry'

const isLocalDev = import.meta.env.DEV
// 한 기기가 끊긴 채 같은 자동 요청을 반복해도 세션당 이만큼만 보낸다
const NETWORK_REPEAT_LIMIT = 3
// 앱 웹뷰가 네트워크 없이 켜지면 부팅 요청이 한꺼번에 끊긴다. 이 시간 안의 network 실패는 첫 건만 보낸다
const NETWORK_BURST_WINDOW_MS = 3_000

export const reporter = createReporter({
  policy: studentPolicy,
  adapters: [sentryAdapter],
  debug: isLocalDev,
  dropMode: resolveDropMode(import.meta.env.VITE_ERROR_REPORTING_DROP_MODE),
  tagSampleRate: resolveTagSampleRate(import.meta.env.VITE_ERROR_REPORTING_TAG_SAMPLE_RATE),
  networkRepeatLimit: NETWORK_REPEAT_LIMIT,
  networkBurstWindowMs: NETWORK_BURST_WINDOW_MS,
  onDrop: isLocalDev
    ? (error) => console.info('[error-reporting] dropped', error.origin, error.code, error.message)
    : undefined,
})
